// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollToTopButton_button__DDiD_","visible":"ScrollToTopButton_visible__wOtr1","icon":"ScrollToTopButton_icon__fhZoc"};